import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@clean-code/shared/util-config';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';
import { IMarketCustomerAnalysisWidgetContent } from '../market-customer-analysis-widget-content/market-customer-analysis-widget-content.models';
import { MarketCustomerAnalysisWidgetTypeConfig } from '../market-customer-analysis-widget.models';
import { WidgetCompany } from '../widget-company';

@Injectable({
  providedIn: 'root',
})
export class MarketCustomerAnalysisWidgetService {
  private graphqlService = inject(GraphqlService);
  private configService = inject(ConfigService);
  private url = this.configService.settings['api'] + 'contacts/graphql';

  public dashboardCustomerOverviewById$(
    value: MarketCustomerAnalysisWidgetTypeConfig,
  ): Observable<IMarketCustomerAnalysisWidgetContent> {
    const query = `
          query($id: Int!) {
            dashboardCustomerOverviewById(id: $id) {
              customer {
                name
                segment
                active
                kam {
                  power
                  gas
                }
                users {
                  active
                  inactive
                }
              }

              offer {
                power { active inactive }
                gas { active inactive }
              }

              loadProfile {
                power { active inactive }
                gas { active inactive }
              }

              forecast {
                power { active inactive }
                gas { active inactive }
              }

              contracts {
                power { active inactive }
                gas { active inactive }
              }

              limitReports {
                power {
                  open
                  closed
                  closedPercentage
                }
                gas {
                  open
                  closed
                  closedPercentage
                }
                other {
                  open
                  closed
                  closedPercentage
                }
              }

              energyOrders {
                power {
                  energyOrder { active inactive waitingApproval }
                  spreadEnergyOrder { active inactive waitingApproval }
                  spot { active inactive waitingApproval }
                  spotSpread { active inactive waitingApproval }
                  strategyMessage { active inactive waitingApproval }
                  strategyMessageSpread { active inactive waitingApproval }
                  limitOrder { active inactive waitingApproval }
                  hkn { active inactive waitingApproval }
                  hknLimitOrder { active inactive waitingApproval }
                  tradingRequest { active inactive waitingApproval }
                }
                gas {
                  energyOrder { active inactive waitingApproval }
                  spot { active inactive waitingApproval }
                  strategyMessage { active inactive waitingApproval }
                  limitOrder { active inactive waitingApproval }
                  tradingRequest { active inactive waitingApproval }
                }
              }
            }
          }`;

    return this.graphqlService.query<IMarketCustomerAnalysisWidgetContent>(
      query,
      {
        id: +value.companyId,
      },
      null,
    );
  }

  public getAllCompanies$(): Observable<WidgetCompany[]> {
    const query = `
      query {
        allCompanies {
          id
          name
          segmentId
          segment {
            name
          }
          disabled
          personId
          superId
          partnerIdPower
          partnerIdGas
        }
      }
    `;

    return this.graphqlService.query<WidgetCompany[]>(query);
  }
}
